// グリッド吸着の有効/無効をローカルストレージに保存するユーティリティ。
// 既定は OFF（不在時は false）。値は "on" / "off" の文字列。

const STORAGE_KEY = "refinement-canvas:grid-snap-enabled";

export function loadGridSnapPreference(): boolean {
  try {
    if (typeof localStorage === "undefined") return false;
    return localStorage.getItem(STORAGE_KEY) === "on";
  } catch {
    return false;
  }
}

export function saveGridSnapPreference(enabled: boolean): void {
  try {
    if (typeof localStorage === "undefined") return;
    localStorage.setItem(STORAGE_KEY, enabled ? "on" : "off");
  } catch {
    // 保存できない場合は無視（プライベートブラウジング等）。
  }
}
